import { RQParam, RQHandlers, RQService, RQApp } from '../../RQuery/RQuery';
import { dmHotel }                               from '../sign-in/xv-hotel';
import { MLText, mlBroker }                      from '../../services/MLText';
import { dmLoading }                             from '../loading/loading';

export class dmTaskEntry {
    Task:               RQService.Tasks.ExtGetAllRoomCleaningTasksRow
    TaskType:           RQService.Tasks.GetCleaningTaskTypesRow

    AssetsDir:          string;
    CleanStatusIcon:    string;

    HandledStatusClass: string;

    constructor(
         pTask:      RQService.Tasks.ExtGetAllRoomCleaningTasksRow
        ,pTaskTypes: RQService.Tasks.GetCleaningTaskTypesRow[]
        ,app:        mlBroker
    ) {
        let gotMatch: boolean = false;

        this.Task = pTask;

        for (let i = 0; i < pTaskTypes.length; i++) {
            if (
                pTaskTypes[i].TaskTypeID             == this.Task.TaskTypeID
            &&  pTaskTypes[i].ExtraReservationTaskID == this.Task.ExtraReservationTaskID
            ) {
                this.TaskType = pTaskTypes[i];

                gotMatch = true;
            }
        }

        if (!gotMatch) {
            if (pTaskTypes.length > 0) {
                this.TaskType = pTaskTypes[0];
            } else {
                let noTask: any = {};

                noTask.TaskTypeID             = 0;
                noTask.ExtraReservationTaskID = 0;
                noTask.TaskTypeName           = app.Text('NoTask', '(no task)');

                this.TaskType = RQService.Tasks.PopulateGetCleaningTaskTypesRow({});
            }
        }

        if (RQApp.IsPageContext) { this.AssetsDir = '/assets';  }
        else                     { this.AssetsDir = './assets'; }

        this.CleanStatusIcon = this.AssetsDir + '/imgs/';

        if (this.Task.RoomCleanStatusID == 1) {
            this.CleanStatusIcon += 'clean-icon.png';
        } else {
            this.CleanStatusIcon += 'dirty-icon.png';
        }

        if (this.Task.HandledStatusID == 1) {
            this.HandledStatusClass = 'tb-task-created';
        } else if (this.Task.HandledStatusID >= 4) {
            this.HandledStatusClass = 'tb-task-closed';
        } else if (
            this.Task.ExtraReservationTaskID == 0
        &&  this.Task.TaskTypeID             != 5
        &&  this.Task.OccupancyStatusID      == 2
        ) {
            this.HandledStatusClass = 'tb-task-not-ready';
        } else if (
            (
                this.Task.ExtraReservationTaskID != 0
            ||  this.Task.TaskTypeID             == 5
            )
        &&  this.Task.HandledStatusID          == 2
        &&  this.Task.RoomDoNotDisturbStatusID == 2
        ) {
            this.HandledStatusClass = 'tb-task-not-ready';
        } else if (
            this.Task.HandledStatusID == 3
        ) {
            this.HandledStatusClass = 'tb-task-inprogress';
        } else if (
            this.Task.HandledStatusID == 2
        ) {
            this.HandledStatusClass = 'tb-task-ready';
        } else {
            this.HandledStatusClass = 'tb-task-none';
        }
    }
}

export class TaskListViewModel {
    ShowAlert:         (pTitle: string, pMessage: string) => void;
    BackToSignIn:      ()                                 => void;
    NewLoading:        (pMessage: string)                 => dmLoading;
    ShowOrderBySelect: ()                                 => void;
    ShowCalendar:      (
         pToday:   Date
        ,pCDay:    Date
        ,pTitle:   string
        ,pLangID:  number
        ,pAction:  (pCDay: Date)                          => void
    )                                                     => void;

    mlText:            MLText;
    app:               mlBroker;
    ml:                mlBroker;
    Hotel:             dmHotel;
    LangID:            number;

    CDayModified:      boolean;
    CDayDisplay:       string;
    CDay:              Date;               
    Today:             Date;

    Interval:          number;

    InRefresh:         boolean;
    PageActive:        boolean;
    TimerActive:       boolean;
    CallbackPending:   boolean;
    PageInitialised:   boolean;

    SetTaskTitle:      string;
    SetStaffTitle:     string;
    SetSortTitle:      string;

    OrderByStatus:     boolean;

    Staff:             RQService.Tasks.GetStaffRow[];
    TaskTypes:         RQService.Tasks.GetCleaningTaskTypesRow[];
    Tasks:             dmTaskEntry[];

    constructor(
         pMLText:            MLText
        ,pHotel:             dmHotel
        ,pBackToSignIn:      ()                                 => void
        ,pShowAlert:         (pTitle: string, pMessage: string) => void
        ,pNewLoading:        (pMessage: string)                 => dmLoading 
        ,pShowOrderBySelect: ()                                 => void
        ,pShowCalendar:      (
             pToday:  Date
            ,pCDay:   Date
            ,pTitle:  string
            ,pLangID: number
            ,pAction: (pCDay: Date) => void
        )                                                       => void
    ) {
        console.log('init task list page instance');

        this.mlText            = pMLText;
        this.LangID            = this.mlText.GetLangID();
        this.app               = this.mlText.GetBroker(
            'BookingEngineAppTexts'
        );
        this.ml                = this.mlText.GetBroker(
            'CTMExtranetTaskList'
        );

        this.Hotel             = pHotel;
        this.BackToSignIn      = pBackToSignIn;
        this.ShowAlert         = pShowAlert;
        this.NewLoading        = pNewLoading;
        this.ShowOrderBySelect = pShowOrderBySelect;
        this.ShowCalendar      = pShowCalendar;

        this.Interval          = 120;
        this.Interval          = this.Interval * 1000;

        this.InRefresh         = false;
        this.PageActive        = false;
        this.TimerActive       = false;
        this.CallbackPending   = false;
        this.PageInitialised   = false;

        this.SetTaskTitle      = this.ml.Text('SetCleaningTask'   ,'Set Cleaning Task');
        this.SetStaffTitle     = this.ml.Text('AssignStaffMember' ,'Assign Staff Member');
        this.SetSortTitle      = this.ml.Text('SortBy'            ,'SortBy');

        this.Staff             = [];
        this.TaskTypes         = [];
        this.Tasks             = [];

        this.OrderByStatus     = false;

        this.CDayModified      = false;

        this.updateNotionOfToday();

        this.CDay              = this.Today;

        this.CDayDisplay       = this.CDay.toLocaleDateString(
             RQApp.LangCodesByID[this.LangID]
            ,{
                 weekday: 'long'
                ,year:    'numeric'
                ,month:   'long'
                ,day:     'numeric'
            }
        );

        let loading: dmLoading = this.NewLoading(
            this.app.Text('LoadingMark' ,'Loading...')
        );

        loading.Show(() => {
            let staffParams = RQParam.TasksGetStaffParams();

            staffParams.HotelID = this.Hotel.HotelID;
            staffParams.LangID  = this.LangID;

            RQService.Tasks.GetStaff(staffParams).then((result) => {
                let response = result as any;

                if (response.HasErrorOrException) { loading.Dismiss(); return; }

                let staffList = response.RQueryResult;

                this.Staff.length = 0;

                for (let i = 0; i < staffList.length; i++) {
                    let staffEntry = RQService.Tasks.PopulateGetStaffRow(
                        staffList[i]
                    );
               
                    console.log('staff item');

                    this.Staff.push(staffEntry);
                }

                let taskTypeParams = RQParam.TasksGetCleaningTaskTypesParams();

                taskTypeParams.HotelID = this.Hotel.HotelID;
                taskTypeParams.LangID  = this.Hotel.LangID;

                RQService.Tasks.GetCleaningTaskTypes(taskTypeParams).then((result) => {
                    let response = result as any;
                    
                    if (response.HasErrorOrException) { loading.Dismiss(); return; }

                    let taskTypeList = response.RQueryResult;

                    this.TaskTypes.length = 0;

                    for (let i = 0; i < taskTypeList.length; i++) {
                        let taskTypeEntry = RQService.Tasks.PopulateGetCleaningTaskTypesRow(
                            taskTypeList[i]
                        );
                   
                        console.log('task type item');

                        if (taskTypeEntry.TaskTypeID == 0) {
                            taskTypeEntry.TaskTypeName = this.app.Text('NoTask', '(no task)');
                        }

                        if (taskTypeEntry.TaskTypeID != 5) {
                            this.TaskTypes.push(taskTypeEntry);
                        }
                    }

                    this.refreshList(() => {
                        loading.Dismiss();
                    
                        this.runTimer(true);
                    }); 
                });
            });
        });
    }

    private updateNotionOfToday(): void {
        let now    = new Date();
        
        this.Today = new Date(
             now.getFullYear()
            ,now.getMonth()
            ,now.getDate()
        );

        if (!this.CDayModified) {
            this.CDay        = this.Today;

            this.CDayDisplay = this.CDay.toLocaleDateString(
                 RQApp.LangCodesByID[this.LangID]
                ,{
                     weekday: 'long'
                    ,year:    'numeric'
                    ,month:   'long'
                    ,day:     'numeric'
                }
            );
        }
    }

    private refreshList(pAction: () => void): void {
        if (this.InRefresh) { pAction(); return; }

        this.InRefresh = true;

        this.updateNotionOfToday();

        let listParams = RQParam.TasksExtGetAllRoomCleaningTasksParams();

        listParams.HotelID         = this.Hotel.HotelID;
        listParams.RoomTypeID      = 0;
        listParams.CDay            = RQApp.JSDateToRQString(this.CDay, false);
        listParams.OrderByStatus   = (this.OrderByStatus) ? 1 : 0;
        listParams.LangID          = this.LangID;

        RQService.Tasks.ExtGetAllRoomCleaningTasks(listParams).then((result) => {
            let response = result as any;

            if (response.HasErrorOrException) {
                pAction();

                this.InRefresh = false;

                return;
            }

            let taskList = response.RQueryResult;

            this.Tasks.length = 0;

            for (let i = 0; i < taskList.length; i++) {
                let taskEntry = RQService.Tasks.PopulateExtGetAllRoomCleaningTasksRow(
                    taskList[i]
                );

                console.log('task list item');

                this.Tasks.push(new dmTaskEntry(taskEntry, this.TaskTypes, this.app));
            }

            this.InRefresh = false;

            pAction();
        });
    }

    private runTimer(pInit: boolean): void {
        console.log('timer tick ' + this.PageActive);

        if (!this.PageActive) { return; }

        this.TimerActive = true;

        setTimeout(
             () => { this.TimerActive = false; this.runTimer(false); }
            ,this.Interval
        );

        if ((!pInit) && this.PageActive && (!this.InRefresh)) {
            if (this.CallbackPending) { return; }

            this.CallbackPending = true;

            let loading: dmLoading = this.NewLoading(
                this.app.Text('LoadingMark', 'Loading...')
            );

            loading.Show(() => {
                this.refreshList(() => {
                    loading.Dismiss();

                    this.CallbackPending = false;

                    return;
                });
            });
        }
    }

    public TaskTypeCompare(
         tt1: RQService.Tasks.GetCleaningTaskTypesRow
        ,tt2: RQService.Tasks.GetCleaningTaskTypesRow
    ): boolean {
        return (
            tt1.TaskTypeID             == tt2.TaskTypeID
        &&  tt1.ExtraReservationTaskID == tt2.ExtraReservationTaskID
        );
    }

    public SetRoomTaskState(
         $event: any
        ,task:   dmTaskEntry
    ): void {
        if (this.InRefresh) { return; }

        console.log('room task state change');

        let taskType = $event as RQService.Tasks.GetCleaningTaskTypesRow;

        if (
            task.TaskType.TaskTypeID             == taskType.TaskTypeID
        &&  task.TaskType.ExtraReservationTaskID == taskType.ExtraReservationTaskID
        ) {
            return;
        }

        let loading: dmLoading = this.NewLoading(
            this.app.Text('SavingMark' ,'Saving...')
        );

        loading.Show(() => {
            let setTaskStateParams = RQParam.TasksExtSetRoomCleaningTaskStateParams();

            setTaskStateParams.HotelID                = this.Hotel.HotelID;
            setTaskStateParams.RoomID                 = task.Task.LocationID;
            setTaskStateParams.CDay                   = RQApp.JSDateToRQString(this.CDay, false);
            setTaskStateParams.TaskTypeID             = taskType.TaskTypeID;
            setTaskStateParams.ExtraReservationTaskID = taskType.ExtraReservationTaskID;
            setTaskStateParams.UserID                 = 1;

            RQService.Tasks.ExtSetRoomCleaningTaskState(setTaskStateParams).then((result) => {
                let response = result as any;

                if (response.HasErrorOrException) { loading.Dismiss(); return; }

                this.refreshList(() => { loading.Dismiss(); });
            });
        });
    }

    public RefreshList(): void {
        if (this.InRefresh) { return; }

        let loading: dmLoading = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')
        );

        loading.Show(() => {
            this.refreshList(() => {
                loading.Dismiss();

                return;
            });
        });
    }

    public OpenOrderBySelect(): void {
        if (this.InRefresh) { return; }

        this.ShowOrderBySelect();
    }

    public SetOrderByState($event: any): void {
        let orderByParam: number = $event as number;

        this.OrderByStatus = (orderByParam == 1) ? true: false;

        let loading: dmLoading = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')
        );

        loading.Show(() => {
            this.refreshList(() => {
                loading.Dismiss();

                return;
            });
        });
    }

    public SetStaffAssignment(
         staffID: number
        ,task:    dmTaskEntry
    ): void {
        if (this.InRefresh) { return; }

        console.log('room task assignment change');

        if (staffID == task.Task.StaffID) { return; }

        let loading: dmLoading = this.NewLoading(
            this.app.Text('SavingMark' ,'Saving...')
        );

        loading.Show(() => {
            if (staffID == 0) {
                this.refreshList(() => { loading.Dismiss(); });

                return;
            }

            let staffAssignParams = RQParam.TasksAssignTaskToStaffMemberParams();

            staffAssignParams.HotelID    = this.Hotel.HotelID;
            staffAssignParams.LocationID = task.Task.LocationID;
            staffAssignParams.CDay       = RQApp.JSDateToRQString(this.CDay, false);
            staffAssignParams.TaskID     = task.Task.TaskID;
            staffAssignParams.UserID     = 1;
            staffAssignParams.StaffID    = staffID;
            staffAssignParams.LangID     = this.LangID;

            RQService.Tasks.AssignTaskToStaffMember(staffAssignParams).then((result) => {
                let response = result as any;

                if (response.HasErrorOrException) { loading.Dismiss(); return; }

                this.refreshList(() => { loading.Dismiss(); });
            });
        });
    }

    public ChangeListDate(pCDay: Date): void {
        if (this.InRefresh)     { return; }
        if (this.CDay == pCDay) { return; }

        this.CDayModified = true;

        this.CDay         = pCDay;

        this.CDayDisplay  = this.CDay.toLocaleDateString(
             RQApp.LangCodesByID[this.LangID]
            ,{
                 weekday: 'long'
                ,year:    'numeric'
                ,month:   'long'
                ,day:     'numeric'
            }
        );

        let loading: dmLoading = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')
        );

        loading.Show(() => {
            this.refreshList(() => {
                loading.Dismiss();

                return;
            });
        });
    }

    public ShowDateSelector(): void {
        if (this.InRefresh) { return; }

        this.ShowCalendar(
             this.Today
            ,this.CDay
            ,this.ml.Text('ChooseTasksDay' ,'Choose Tasks Day')
            ,this.LangID
            ,(pCDay: Date) => { this.ChangeListDate(pCDay); }
        );
    }

    public SignOut(): void {
        this.Hotel.SignOut((pLogOutResult) => { this.BackToSignIn(); });
    }

    public DidEnter() {
        this.PageActive = true;

        if (!this.PageInitialised) { this.PageInitialised = true; return; }

        let loading: dmLoading = this.NewLoading(
            this.app.Text('LoadingMark' ,'Loading...')
        );

        loading.Show(() => {
            this.refreshList(() => {
                loading.Dismiss();
            
                if (!this.TimerActive) { this.runTimer(true); }
            });
        });
    }

    public DidLeave() {
        this.PageActive = false;
    }
}


// WEBPACK FOOTER //
// ./src/pages/task-list/xv-task-list.ts